import React, { useEffect, useState } from "react";
import Spinner from "../Common/Components/spinner";
import ErrorMessage from "../Common/Components/ErrorMessage";
import { CustomersFileType } from "../Common/Types/types";
import NetworkDiagram from "./NetworkDiagram";
import NetworkDiagramThumb from "./NetworkDiagramThumb";
import { getCustomersSelector } from "../Customers/Slice";
import { useSelector } from "react-redux";
import { updateParams, getParamsSelector } from "../Common/Slices/ParamSlice";
import { CustomersApi } from "../Customers/api";
import { useParams, useSearchParams } from "react-router-dom";

interface NetworkDiagramWidgetProps {
  id: string;
  header: string;
  thumb: boolean;
}

const NetworkDiagramWidget = (props: NetworkDiagramWidgetProps) => {
    const [items, updateItems] = useState<CustomersFileType[]>([]);
    const [latestItem, updateLatestItem] = useState<CustomersFileType>();
    const [diagDownloading, updateDiagDownloading] = useState<boolean>(true);
    const params = useSelector(getCustomersSelector);
    const [errorMessage, setErrorMessage] = useState<string>(null);
    const globalParams = useSelector(getParamsSelector);
    const [urlParams, setSearchParams] = useSearchParams();
    const [urlParamsDone, updateUrlParamsDone] = useState(false);
    const [customerID, updateCustomerID] = useState(null);

    useEffect(() => {
        if (!urlParamsDone) {
            if (urlParams.get("customerId") != null) { 
                updateCustomerID(urlParams.get("customerId"));
            } 
        }
    }, [urlParams]);

    useEffect(() => {
        if (globalParams.customerID != null) {
            updateCustomerID(globalParams.customerID);
        }
    }, [globalParams.customerID]);

    useEffect(() => {
        if (customerID != null) {
            fetchDiagrams();
        }
    }, [customerID]);

    const reformatDate = (dateStr) => {

        if (dateStr.match(/^\d{1,2}\.\d{1,2}\.\d{4} \d{1,2}\.\d{2}\.\d{2}$/)) {
            const [date, time] = dateStr.split(' ');  // Split into date and time parts

            // Split the date into day, month, and year
            const [day, month, year] = date.split('.');

            // Pad day and month with leading zeros if necessary
            const paddedDay = day.padStart(2, '0');
            const paddedMonth = month.padStart(2, '0');

            // Split the time into hours, minutes, and seconds
            const [hours, minutes, seconds] = time.split('.');

            // Pad hours, minutes, and seconds with leading zeros if necessary
            const paddedHours = hours.padStart(2, '0');
            const paddedMinutes = minutes.padStart(2, '0');
            const paddedSeconds = seconds.padStart(2, '0');

            // Return the date in ISO format (yyyy-mm-ddThh:mm:ss)
            return `${year}-${paddedMonth}-${paddedDay}T${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
        }
        else {
            const [date, time] = dateStr.split(' ');  // Split into date and time parts

            // Split the date into day, month, and year
            const [day, month, year] = date.split('.');

            // Pad day and month with leading zeros if necessary
            const paddedDay = day.padStart(2, '0');
            const paddedMonth = month.padStart(2, '0');

            // Split the time into hours, minutes, and seconds
            const [hours, minutes, seconds] = time.split(':');

            // Pad hours, minutes, and seconds with leading zeros if necessary
            const paddedHours = hours.padStart(2, '0');
            const paddedMinutes = minutes.padStart(2, '0');
            const paddedSeconds = seconds.padStart(2, '0');

            // Return the date in ISO format
            return `${year}-${paddedMonth}-${paddedDay}T${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
        }
    };



  const fetchDiagrams = (): void => {
    updateDiagDownloading(true);
    updateItems(null);

    let newParams: any = {};
    newParams.path = customerID + "/NetworkDiagrams/";

    CustomersApi.getCustomerFiles(newParams)
      .then((response: any) => {
        if (response != "canceled") {
          const mappedData = response.map((item) => {
            const { url, name, comment, modifiedBy, modifiedDate } = item;
            return {
              url,
              name,
              comment,
              modifiedBy,
              modifiedDate,
            };
          });
          
          if (mappedData != null && mappedData.length > 0) {
              for (var i = 0; i < mappedData.length; i++) {
                mappedData[i].modifiedDate = reformatDate(mappedData[i].modifiedDate)
              }
              if (mappedData.length > 1) {
                //  console.log(mappedData)
                  mappedData.sort((a, b) => {
                      const dateA: any = new Date(a.modifiedDate); // Reformat and convert to Date object
                      const dateB: any = new Date(b.modifiedDate); // Reformat and convert to Date object
                      return dateB - dateA;  // Sort in descending order (most recent first)
                  });
                
              }
             // console.log(mappedData)
              updateItems(mappedData);

              const latestDataItem = mappedData[0];
            updateLatestItem(latestDataItem);
          }
          updateDiagDownloading(false);
          setErrorMessage(null);
        }
      })
      .catch((error) => {
        if (error.message != "canceled") {
          updateDiagDownloading(false);
          setErrorMessage("Oops something went wrong, unable to get data.");
        }
        console.log(error);
      });
  };


  if (diagDownloading) {
    return <Spinner text="diagram" />;
  }
  else if (items != null && items.length == 0) {
    return (
      <ErrorMessage
        text={"No data found for selected filters."}
        id={props.id}
        header={props.header}
      />
    );
  }
  else if (errorMessage) {
    return (
      <ErrorMessage text={errorMessage} id={props.id} header={props.header} />
    );
  }
  else if (items != null && items.length > 0 ) {
    if (props.thumb) {
      return (
        <NetworkDiagramThumb
          latestItem={latestItem}
          customerId={customerID}
        />
      );
    }
    return (

        <div style={{ overflowY: "scroll", height: "100%" }}>
        <NetworkDiagram items={items} latestItem={latestItem} />
      </div>
    );
  }
  else {
    return <div>No Network Diagram found.</div>;
  }
};
export default NetworkDiagramWidget;
